<template>
  <div  v-if="dRouteData">
    <div class="wrapper wrapper-content animated fadeInRight">
	<div class="row">
		<div class="col-lg-12">
			<div class="ibox float-e-margins">
				<div class="ibox-title">
          <h4>
            Dynamic Routes settings:
          </h4>
				</div>
				<div class="ibox-content">

					<div class="row">
						<div class="enswitch-form-container col-lg-12 col-md-12 col-sm-12 col-xs-12">
							<form name="editCRMUserForm" novalidate="" class="" @submit.prevent="save()" v-if="!loading">

								<div class="row form-group">
									<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label importantColor">*Main:</span>
									<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
										<input name="cid_in" caption="cid_in" v-model="dRouteData.cid_in" type="text" />
									</div>
								</div>

								<div class="row form-group">
									<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label importantColor">*Prefix:</span>
									<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
										<input name="prefix" caption="prefix" v-model="dRouteData.prefix" type="text" />
									</div>
								</div>

								<div class="row form-group">
									<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12 importantColor">*Replace:</span>
									<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12 ">
										<input name="cid_out" caption="cid_out" v-model="dRouteData.cid_out" type="text" />
										<span v-if="!this.isNew" class="d-flex"><b>Last Modified:</b>&nbsp; {{ `  ${dRouteData.last_modified_date}  ${dRouteData.last_modified_time}` }}</span>
									</div>
								</div>

								<!-- <div class="row form-group">
									<span class="col-lg-5 col-md-5 col-sm-5 col-xs-12  control-label">Customer:</span>
									<div class="col-lg-7 col-md-7 col-sm-7 col-xs-12">
										<div class="btn-group">
											<div>
												<b-dropdown id="dropdown-1" :text=dRouteData.customer_name class="my-class" v-model="dRouteData.customerName">
													<b-dropdown-item :key=customerData.id v-for="customerData in dRouteData.customers">
														{{ customerData.customerName }}
													</b-dropdown-item>
												</b-dropdown>
											</div>
										</div>
										<span class="d-flex"><b>Last Modified:</b>&nbsp; {{ `  ${dRouteData.last_modified_date}  ${dRouteData.last_modified_time}` }}</span>
									</div>
								</div> -->

								<hr>
								<div class="row submit-button-container">
									<button type="submit" :disabled="sendInProgress" ref="submitbtn" class="btn btn-success confirm-button ladda-button edit-person-confirm vueadapt" data-style="zoom-out" data-spinner-size="24" data-size="s" data-spinner-color="white" style="display: block;">
										<span class="ladda-label">Save</span>
										<span class="fas fa-spinner fa-pulse"></span>
										<div class="ladda-progress" style="width: 0px"></div>

									</button>
								</div>
							</form>
						</div>
					</div>
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ng-scope" style="margin-bottom: 8px;" ng-if="options.showProgress">
            <div v-if="loading" class="sk-spinner sk-spinner-wave ng-scope" ng-if="options.showProgress" style="display: block;">
              <div class="sk-rect1"></div><div class="sk-rect2"></div><div class="sk-rect3"></div><div class="sk-rect4"></div><div class="sk-rect5"></div></div><!-- end ngIf: options.showProgress --></div><!-- end ngIf: options.showProgress -->
          </div>
		</div>
		</div>
	</div>
</div>
  </div>
</template>

<script>
import {DynamicRoutesApiService} from "../../services/DynamicRoutesApiService";
export default {
	props: ["routeData"],
	data: () => ({
		isNew: null,
		loading: false,
		dRouteData: null,
		sendInProgress: false
	}),
	created() {
		let $injector = this.$root.angularInjector;

		let CoreApiService = $injector.get("CoreApiService");

		this.DynamicRoutesApiService = new DynamicRoutesApiService(CoreApiService);

		this.SwalService = $injector.get("SwalService");
	},
	async mounted() {
		this.loading = true;
		this.isNew = !this.$props.routeData;
		this.dRouteData = !this.isNew ? JSON.parse(this.$props.routeData) : { };
		this.loading = false;
	},
	watch: {
		sendInProgress: function(val) {
			if (val) {
				this.$refs.submitbtn.dataset.loading = "";
			}
			else {
				delete this.$refs.submitbtn.dataset.loading;
			}
		}
	},
	methods: {
		formatCustomersData(customersData) {
			let dataFormatted = [];
			customersData.forEach((value, index) => {
				if (index % 2 === 0) {
					dataFormatted.push({id: value});
				}
				else {
					var last = dataFormatted[dataFormatted.length - 1];
					dataFormatted.splice(dataFormatted.length - 1, 1, {id: last.id, customerName: value});
				}
			});
			return dataFormatted.slice(1, 200);
		},
		async save() {
			this.sendInProgress = true;
			try {
				if (this.isNew) {
					await this.DynamicRoutesApiService.create(this.dRouteData);
				}
				else {
					await this.DynamicRoutesApiService.update(this.dRouteData.id, this.dRouteData);
				}
				this.SwalService.popup({
					title: "Success!"
				}).then(f => {
					this.$router.replace("/list");
				});
			}
			catch (e) {
				this.SwalService.popup({
					title: getErrorMessage(e), type: "error"
				});
			}
			finally {
				this.sendInProgress = false;
			}
		}
	}
};

function getErrorMessage(e) {
	if (e.message == "Bad request") {
		if (e.key == "error_username_in_use") {
			return "Duplicate username";
		}
		else if (e.key == "error_email_exists") {
			return "Duplicate email";
		}
	}
	return e.message || e.statusText || e || "Error";
}
</script>

<style lang="scss" scoped>
.importantColor {
	color: #732;
    font-weight: bold;
    padding: 5px;
}
.my-class /deep/ .dropdown-menu {
    max-height: 240px;
    overflow-y: auto;
  }
.my-class /deep/ a  {
	padding: 1px!important;
	margin: 1px!important;
    line-height: 20px!important;
}
.ibox-content  /deep/ ul {
	width:250px!important;
	margin-left:calc( 50% - 125px) !important;
}
</style>>